import React from 'react'

import MaterialTable from 'material-table'

function Table(props) {
  return <MaterialTable {...props} />
}

export default Table
